import { UseMutationOptions } from 'react-query/types/react/types';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { useMutation, UseMutationResult } from 'react-query';
import { LoginConfigApi } from '../../../api-client';
import { getApiConfiguration } from '../../../common';

type UseSetPrimaryConnectionId = (
  options?: Omit<
    UseMutationOptions<
      AxiosResponse<void>,
      ErrorResponse,
      string | undefined
    >,
    'mutationFn'
  >,
) => UseMutationResult<
  AxiosResponse<void>,
  ErrorResponse,
  string | undefined
>;

export const useSetPrimaryConnectionId: UseSetPrimaryConnectionId = (
  options,
) => {
  const loginConfigApi = new LoginConfigApi(getApiConfiguration());

  return useMutation(
    (id) => loginConfigApi.setPrimaryConnectionId({ connectionId: id }),
    options,
  );
}
